import { handleAPI, API_VERSION_ONE } from '../../../itrust_common/utils/apiUtils'

// Active warranty programs (settings) — for Add Warranty modal
export function orderWarrantiesLoad({ page = 1, rpp = 10 } = {}) {
  return {
    type: 'ORDER_WARRANTIES_LOAD',
    payload: handleAPI(
      `/${API_VERSION_ONE}/settings/warranties`,
      { filter: { status: 'active' }, rpp, page, include: '*' },
      'GET'
    ),
    meta: { page },
  }
}

export function orderWarrantyEyeglassesLoad(orderId, settingsWarrantyId) {
  return {
    type: 'ORDER_WARRANTY_EYEGLASSES_LOAD',
    payload: handleAPI(
      `/${API_VERSION_ONE}/orders/${orderId}/warranties/list_eyeglasses`,
      { settings_warranty_id: settingsWarrantyId },
      'GET'
    ),
  }
}

export function orderWarrantyApply(orderId, body) {
  return {
    type: 'ORDER_WARRANTY_APPLY',
    payload: handleAPI(`/${API_VERSION_ONE}/orders/${orderId}`, { include: '*' }, 'PUT', body),
  }
}

export function orderWarrantiesReset() {
  return { type: 'ORDER_WARRANTIES_RESET' }
}

// Warranties already on the order — for Use Warranty modal
export function orderAppliedWarrantiesLoad(orderId, { page = 1, rpp = 10 } = {}) {
  return {
    type: 'ORDER_APPLIED_WARRANTIES_LOAD',
    payload: handleAPI(
      `/${API_VERSION_ONE}/orders/${orderId}/warranties`,
      { include: '*.*', rpp, page },
      'GET'
    ),
    meta: { page },
  }
}

export function orderWarrantyLoad(orderId, warrantyId) {
  return {
    type: 'ORDER_WARRANTY_LOAD',
    payload: handleAPI(
      `/${API_VERSION_ONE}/orders/${orderId}/warranties/${warrantyId}`,
      { include: '*.*' },
      'GET'
    ),
  }
}

export function orderWarrantyUse(orderId, warrantyId, data) {
  return {
    type: 'ORDER_WARRANTY_USE',
    payload: handleAPI(
      `/${API_VERSION_ONE}/orders/${orderId}/warranties/${warrantyId}`,
      { include: '*.*' },
      'PUT',
      { warranty: data }
    ),
  }
}

export function orderWarrantyDelete(orderId, warrantyId) {
  return {
    type: 'ORDER_WARRANTY_DELETE',
    payload: handleAPI(
      `/${API_VERSION_ONE}/orders/${orderId}/warranties/${warrantyId}`,
      { include: '*.*' },
      'DELETE'
    ),
    meta: { warrantyId },
  }
}

export function orderAppliedWarrantiesReset() {
  return { type: 'ORDER_APPLIED_WARRANTIES_RESET' }
}
